module.exports = __webpack_public_path__ + "img/BAU_Logo.02b4a747.png";